module.exports = __webpack_public_path__ + "img/UpcomingEventsUpdate.2d99e191.png";